/**
 * Meadow Inventory Swap
 *
 * Windsor Wood shows by default while the case-based proxy loads. Once the
 * response arrives, the storefront displays exactly the urns it returns: every
 * in-stock urn (Windsor, Rosewood, Darkwood) at the case's crematory, or
 * Windsor Wood as the fallback when none are in stock. Any managed urn not in
 * the response is hidden (so Windsor is hidden only when it is out of stock and
 * another urn is in stock). The case is identified by the meadow_id stored in
 * session by record-meadow-id.js.
 */
(function () {
  'use strict';

  var PROXY_BASE = '/apps/meadow';
  var SESSION_KEY_MEADOW_ID = 'meadow_id';

  var WINDSOR_URN = '8185977110700';
  var ROSEWOOD_URN = '8415940772012';
  var DARKWOOD_URN = '8512521076908';
  // Gated urns are hidden by default and revealed only when in stock. Windsor
  // Wood is shown by default (the loading placeholder) and hidden later only if
  // the response returns other urns without it.
  var GATED_URNS = [ROSEWOOD_URN, DARKWOOD_URN];
  var MANAGED_URNS = [WINDSOR_URN, ROSEWOOD_URN, DARKWOOD_URN];

  // Hide the gated urns immediately (one style element each) so they never
  // flash. Each is removed individually when that urn is revealed.
  var hideStyles = {};
  function hideGated(productId) {
    var style = document.createElement('style');
    style.textContent =
      '.grid__item:has(> .card-wrapper[data-product-id="' + productId + '"]) { display: none !important; }' +
      ' .card-wrapper[data-product-id="' + productId + '"] { display: none !important; }';
    document.head.appendChild(style);
    hideStyles[productId] = style;
  }
  GATED_URNS.forEach(hideGated);

  function getMeadowId() {
    var params = new URLSearchParams(window.location.search);
    var meadowId = params.get('meadow_id') || sessionStorage.getItem(SESSION_KEY_MEADOW_ID);
    if (params.get('meadow_id')) {
      sessionStorage.setItem(SESSION_KEY_MEADOW_ID, params.get('meadow_id'));
    }
    return meadowId;
  }

  function cardElements(productId) {
    var els = [];
    var cards = document.querySelectorAll('.card-wrapper[data-product-id="' + productId + '"]');
    for (var i = 0; i < cards.length; i++) {
      els.push(cards[i].closest('.grid__item') || cards[i]);
    }
    return els;
  }

  function showProduct(productId) {
    var style = hideStyles[productId];
    if (style && style.parentNode) {
      style.parentNode.removeChild(style);
      delete hideStyles[productId];
    }
    cardElements(productId).forEach(function (el) {
      el.style.display = '';
      // Our CSS hides gated cards before Dawn's scroll-animation observer runs,
      // so the observer marks them offscreen (opacity: 0.01). Cancel the
      // animation on show so the card is immediately visible.
      if (el.classList.contains('scroll-trigger')) {
        el.classList.remove('scroll-trigger--offscreen');
        el.classList.add('scroll-trigger--cancel');
      }
    });
  }

  function hideProduct(productId) {
    cardElements(productId).forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function onProductPage(productId) {
    return !!document.querySelector('product-info[data-product-id="' + productId + '"]');
  }

  async function init() {
    // No case in context: keep the gated urns hidden and show Windsor only.
    var meadowId = getMeadowId();
    if (!meadowId) return;

    try {
      var response = await fetch(
        PROXY_BASE + '/case-products?case_id=' + encodeURIComponent(meadowId)
      );
      if (!response.ok) {
        console.error('[meadow-swap] Proxy request failed:', response.status);
        return;
      }
      var data = await response.json();
      if (!data || !data.products || data.products.length === 0) return;

      // The response is the display set. Show exactly the urns returned and
      // hide every managed urn that is not (this hides the default Windsor when
      // in-stock gated urns come back instead).
      var handleById = {};
      var firstHandle = null;
      for (var i = 0; i < data.products.length; i++) {
        var product = data.products[i];
        var productId = product.product_id && product.product_id.split('/').pop();
        if (!productId) continue;
        handleById[productId] = product.handle;
        if (firstHandle === null) firstHandle = product.handle;
      }

      for (var j = 0; j < MANAGED_URNS.length; j++) {
        var urnId = MANAGED_URNS[j];
        if (handleById[urnId]) {
          showProduct(urnId);
        } else {
          hideProduct(urnId);
          // On a hidden urn's product page, send the customer to a shown urn.
          if (onProductPage(urnId) && firstHandle) {
            var redirectUrl = '/products/' + firstHandle;
            if (meadowId) redirectUrl += '?meadow_id=' + encodeURIComponent(meadowId);
            window.location.replace(redirectUrl);
            return;
          }
        }
      }
    } catch (err) {
      console.error('[meadow-swap] Error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
